import { render, staticRenderFns } from "./EventLinkWrapper.vue?vue&type=template&id=3ac5678c&scoped=true"
import script from "./EventLinkWrapper.vue?vue&type=script&lang=ts"
export * from "./EventLinkWrapper.vue?vue&type=script&lang=ts"
import style0 from "./EventLinkWrapper.vue?vue&type=style&index=0&id=3ac5678c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac5678c",
  null
  
)

export default component.exports